<template>
  <div class="error_container" :class="imgSrc.includes('cont') ? 'error_cont' : ''" :style="{...selfStyle}">
    <img :src="imgSrc" alt="" class="img" :class="imgSrc.includes('cont') ? 'img_cont' : ''" />
    <span>{{ info }}</span>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
interface IProps {
  status?: {
    info?: String
    imgSrc?: String
  },
  selfStyle?: Object
}
const props = withDefaults(defineProps<IProps>(), {
  status: () => {
    return {
      info: '',
      imgSrc: ''
    }
  },
  selfStyle: () => {
    return {}
  }
})
const info = ref<String>(props.status?.info || '暂无内容')
const imgSrc = ref(props.status.imgSrc ? require('@/assets/images/empty/' + props.status?.imgSrc) : require('@/assets/images/empty/empty.png'))
watch(
  () => props.status,
  (newValue) => {
    info.value = newValue.info || '暂无内容'
    imgSrc.value = newValue.imgSrc ? require('@/assets/images/empty/' + newValue.imgSrc) : require('@/assets/images/empty/empty.png')
  },
  { deep: true }
)
</script>

<style scoped lang="less">
.error_container {
  width: calc(100vw);
  height: calc(100vh - 200px);
  background-color: #f4f5f7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  span {
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    display: block;
    margin-top: 8px;
    text-align: center;
  }
  .img {
    width: 178px;
    height: 178px;
  }
  .img_cont {
    width: 115px;
    height: 115px;
  }
}
.error_cont {
  width: 100%;
  height: unset;
  background-color: transparent;
}
</style>
